import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {ProgressiveImageConfig, ProgressiveImage} from "./progressive_image";

export const progressiveImageLoader = function (options = {}) {
    componentLoader(componentConfig(ProgressiveImage, ProgressiveImageConfig.componentTypeKey, ProgressiveImageConfig.baseHtmlClass), options);
};
